module.exports = __webpack_public_path__ + "img/20201102_195123.ddc04967.jpg";